import React, { useCallback, useContext, useEffect, useState } from 'react';
import { ModalDispatchContext } from '../../../../../ui/modal/ModalContext';
import { isPreview } from '../../../../../../utils/common';
import OneButtonModal from '../../../../../ui/modal/standard/OneButtonModal';
import Messaging from '../../../../../../context/Messaging';

interface Props {
  // eslint-disable-next-line
  user: any;
  stepNum: number;
  introStep: number;
}

export const useShowPreviewModal = ({ user, stepNum, introStep }: Props) => {
  const dispatchModal = useContext(ModalDispatchContext);
  const [showPreviewModal, setPreviewShowModal] = useState(false);
  const [modalContent, setModalContent] = useState<{
    buttonLabel: React.ReactNode;
    title: React.ReactNode;
    body: React.ReactNode;
  } | null>(null);

  const previewPrompt = useCallback(() => {
    if (isPreview(user?.role, user?.mode, user?.active)) {
      setPreviewShowModal(true);
    }
  }, [user]);

  useEffect(() => {
    if (stepNum === introStep) {
      // eslint-disable-next-line
      previewPrompt();
    }
  }, [stepNum, introStep, previewPrompt]);

  useEffect(() => {
    if (showPreviewModal) {
      // eslint-disable-next-line
      setModalContent({
        buttonLabel: <Messaging dynamic preview section='modal.button' />,
        title: <Messaging dynamic preview section='modal.header' />,
        body: <Messaging dynamic preview section='modal.body' />,
      });
    }
  }, [showPreviewModal]);

  useEffect(() => {
    if (showPreviewModal && modalContent) {
      dispatchModal(
        <OneButtonModal
          buttonLabel={modalContent.buttonLabel}
          title={modalContent.title}
          onClose={() => setPreviewShowModal(false)}
          body={modalContent.body}
          modalId='you-are-all-set-modal'
          variant='info'
        />
      );
    }
  }, [showPreviewModal, modalContent, dispatchModal]);
};
